import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import CourseSectionStatusService from "../../src/Services/CourseSectionStatus.service";
const CourseSectionStatusLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        // @ts-expect-error - TS2322 - Type 'number[]' is not assignable to type 'string[]'.
        defaultIds: props.defaultIds,
        // @ts-expect-error - TS2322 - Type '(ids: number[]) => Promise<CourseSectionStatus[]>' is not assignable to type '(ids: string[]) => Promise<CourseSectionStatus[]>'.
        fetchItemsById: (ids) => {
            return CourseSectionStatusService.findByIds(ids);
        },
        fetchOptions: (search) => {
            return CourseSectionStatusService.searchAll(search);
        },
        optionRenderer: function optionRenderer(courseSectionStatus) {
            return _jsx("span", { children: courseSectionStatus.name });
        },
    });
};
export default CourseSectionStatusLookup;
